import React, { useEffect, useRef } from "react";
import "../theme.css";

export const ModalV2: React.FC<{
  isOpen: boolean;
  onClose?: () => void;
  children: React.ReactNode;
  style?: React.CSSProperties;
  titleId?: string;
}> = ({ isOpen, onClose, children, style, titleId }) => {
  const panel = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!isOpen) return;
    const previous = document.activeElement as HTMLElement | null;
    panel.current?.querySelector<HTMLElement>("input:not(:disabled), textarea:not(:disabled), select:not(:disabled), button:not(:disabled), a[href]")?.focus();
    return () => { if (previous?.isConnected) previous.focus(); };
  }, [isOpen]);
  if (!isOpen) return null;
  return <div style={{ position: "fixed", inset: 0, zIndex: 1000, padding: 20, backgroundColor: "rgba(0, 0, 0, 0.65)", display: "flex", justifyContent: "center", alignItems: "center" }} onClick={() => onClose?.()}>
    <div ref={panel} role="dialog" aria-modal="true" aria-labelledby={titleId}
      onClick={event => event.stopPropagation()}
      onKeyDown={event => {
        if (event.key === "Escape") { event.preventDefault(); onClose?.(); }
        if (event.key !== "Tab") return;
        const buttons = panel.current?.querySelectorAll<HTMLElement>("input:not(:disabled), textarea:not(:disabled), select:not(:disabled), button:not(:disabled), a[href]");
        if (!buttons?.length) return;
        const first = buttons[0], last = buttons[buttons.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }}
      style={{ backgroundColor: "var(--ui-surface)", border: "1px solid var(--ui-outline)", padding: 20, borderRadius: "var(--ui-radius)", width: 400, maxWidth: "100%", maxHeight: "90vh", overflow: "auto", position: "relative", fontFamily: "var(--ui-font)", color: "var(--ui-text)", ...style }}>
      {children}
    </div>
  </div>;
};
